import axios from '../../../axiosConfig';

export async function handleUploadFile(config = {}, data) {
    return await axios.post(`/v1/depreciation-group/import`, data, config);
}

export async function handleUploadFileChartOfAccount(config = {}, data) {
    return await axios.post(`/v1/chart-of-account/import`, data, config);
}

export async function handleUploadFileAsset(config = {}, data) {
    return await axios.post(`/v1/asset/import`, data, config);
}

const functions = { handleUploadFile, handleUploadFileChartOfAccount, handleUploadFileAsset }
export default functions
